/* file description */
import CascadePage from './CascadePage';

// export type { SpRecordAsseProps } from './sp-record-asset';
export default CascadePage;

